import { render, staticRenderFns } from "./FlowsList.vue?vue&type=template&id=0622f722&"
import script from "./FlowsList.vue?vue&type=script&lang=js&"
export * from "./FlowsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports